var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareJewelBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 301,
    viewBox: "0 0 300 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.869 0H50.1307C22.4412 0 0 22.4412 0 50.1307V249.869C0 277.559 22.4412 300 50.1307 300H249.869C277.559 300 300 277.559 300 249.869V50.1307C300 22.4412 277.559 0 249.869 0ZM245.466 229.63C245.466 238.377 238.377 245.466 229.63 245.466H70.37C61.6228 245.466 54.5345 238.377 54.5345 229.63V70.37C54.5345 61.6228 61.6228 54.5345 70.37 54.5345H229.63C238.377 54.5345 245.466 61.6228 245.466 70.37V229.63ZM118.178 190.72C113.141 190.72 109.099 186.648 109.099 181.611V118.027C109.099 112.99 113.141 108.888 118.178 108.888H181.852C186.859 108.888 190.931 112.96 190.931 118.027V181.581C190.931 186.618 186.859 190.69 181.852 190.69H118.178V190.72Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareJewelBlack);
export default __webpack_public_path__ + "static/media/Square_Jewel_Black.015ca8f832bbad0bfb1129e8f8264a76.svg";
export { ForwardRef as ReactComponent };